/**
 * @prettier
 * @flow
 */
import type { AccountId } from 'src/types/Id';

export function getAccountIdInLocalStorage(): AccountId | void {
    const item = window.localStorage.getItem(KEY_NAME);
    return item ? JSON.parse(item) : undefined;
}

export const KEY_NAME = 'accountId';
